import { FaArrowRight, FaMapMarkerAlt, FaSlash, FaDrawPolygon, FaRegCircle, FaRegSquare } from 'react-icons/fa';
import { Table } from 'reactstrap';
import Moment from 'moment';
const BioDiversityItemView = ({ item, handleItemHighlight, handleItemView }) => {
    return (
        <>
            <tr style={{ background:"#F0F0F0" }}>
            <td style={{width:"5%"}}>
                <a onMouseOver={(itemId) => handleItemHighlight(item.itemId)} onMouseOut={(itemId) => handleItemHighlight(0)}>
                        {item.mapMarkerType == 'marker' ? <FaMapMarkerAlt color={item.colour}></FaMapMarkerAlt> :
                            item.mapMarkerType == 'polyline' ? <FaSlash color={item.colour}></FaSlash> :
                                item.mapMarkerType == 'polygon' ? <FaDrawPolygon color={item.colour}></FaDrawPolygon> :
                                    item.mapMarkerType == 'circle' ? <FaRegCircle color={item.colour}></FaRegCircle> :
                                        item.mapMarkerType == 'rectangle' && <FaRegSquare color={item.colour}></FaRegSquare>}
                    </a>
                </td>
            <td style={{ width: "20%" }}>{item.name} </td>
            <td style={{ width: "20%" }}>{item.itemTypeName} </td>
            <td style={{ width: "50%",fontSize:"13px" }}>{item.bioDiversityComment} </td>
            <td style={{ width: "5%" }}>
                <button type="button" id={"view" + item.itemId}
                    onClick={(itemId, routePath) => handleItemView(item.itemId, item.routePath)}
                    className="btn btn-primary btn-sm">
                    View
                </button>
                </td>
        </tr>
            {
                item.actionList != undefined && item.actionList != null && item.actionList.length > 0 &&
                <>
                    <tr>
                        <td style={{ width: "5%" }}></td>
                        <td style={{ width: "90%" }} colspan="3">
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th colspan="4" style={{ background:"#e6f0f9" }}>Actions</th>
                                    </tr>
                                    <tr>
                                        <th>#</th>
                                        <th>Due</th>
                                        <th>Title</th>
                                        <th>Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {item.actionList != undefined && item.actionList != null && item.actionList.map(action => (
                                        <>
                                            <tr className="openAction">
                                                <td style={{ width: "10%" }}>{action.id} </td>
                                                <td style={{ width: "20%" }}>{action.actionType == 46 ? "Ongoing / Management" : Moment(action.dueDate).format('DD/MM/YYYY')} </td>
                                                <td style={{ width: "30%" }}>{action.title} </td>
                                                <td style={{ width: "30%" }}>{action.description} </td>
                                            </tr>
                                        </>
                                    ))}
                                </tbody>
                            </Table>
                        </td>
                        <td style={{ width: "5%" }}></td>
                    </tr>
                </>
            }
        </>
        )
}
export default BioDiversityItemView;